import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import { Communication } from "../../contexts/communicationContext";
import { Auth } from "../../contexts/ridersUserContext";
import { Editor, FileSystem, MiniBrowser, QAChapter, Screen } from "./";

import { Spin } from "antd";
import { FormattedMessage } from "react-intl";
import { LanguageContext } from "../../contexts/languageContext";
import { BEditor } from "./Blockly/Blockly";
import { BEditor as DeneyapBlock } from "./DeneyapBlock/Blockly";
import { BEditor as MicrobitBlock } from "./Microbit/Blockly";
import { BEditor as RidersBlock } from "./RidersBlock/Blockly";

export const Tablist = ({
  style,
  tabs,
  workspaceId,
  checkPoint,
  isResizing,
}: any) => {
  const {
    setEditorFocus,
    projectConfig,
    // project,
    documentationRef,
    setPythonCode,
    collapsedSidebar,
    blocklyKey,
  } = useContext<any>(Screen.context);

  const { language } = useContext<any>(LanguageContext);

  const { writeFile } = useContext<any>(FileSystem.context);
  const [editorId, setEditorId] = useState("");

  const { project, isBranchOwner } = useContext<any>(Auth.context);
  const { activeChapter, chapterKey, refreshKey } = useContext<any>(
    Screen.context
  );

  const [fullscreen, setFullscreen] = useState<null | string>(null);
  const [preview, setPreview] = useState<boolean>(false);

  const documentationPath = activeChapter?.cells.find(
    (x: any) => x.type === "Documentation"
  )?.relativePath;

  const powerpointPath = activeChapter?.cells.find(
    (x: any) => x.type === "Powerpoint"
  )?.relativePath;

  const quizId = activeChapter?.cells.find((x: any) => x.type === "QA")?.quizId;

  const getNewUrl = (path: string) => {
    if (project.documentationUrl) {
      return project.documentationUrl.replace("index.html", path);
    } else {
      return `https://d32lhafmwoak77.cloudfront.net/content/internal/${project.project_id}/${path}`;
    }
  };

  const { filePath, blocklySource } = useContext<any>(Communication.context);

  useEffect(() => {
    setEditorId(Math.random().toString(36).substring(7));
  }, [chapterKey]);

  return (
    <div
      style={style}
      id={`tablist-${workspaceId}`}
      className="fit overflow-hidden"
    >
      <div
        className={classNames(
          tabs.length > 1 ? "grid gap-5 grid-cols-1" : "",
          checkPoint ? "grid-rows-[0.6fr_1fr]" : "grid-rows-[1fr_0.6fr]",
          "fit"
        )}
      >
        {tabs.map((tab: any) => {
          switch (tab.type) {
            case "QA":
              return (
                <div className="w-full h-full bg-white dark:bg-vs-dark-background-lighter rounded-[30px] p-8 overflow-y-scroll">
                  <QAChapter quizId={quizId} />
                </div>
              );
            case "iframe":
              return (
                <div
                  className={classNames(
                    checkPoint ? "order-1 border-2 border-riders-green" : "",
                    "fit order-1 relative rounded-[30px] dark:bg-vs-dark-background-lighter overflow-hidden bg-white documentation-tab"
                  )}
                  key={tab.id}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: isResizing ? 1000 : -1,
                    }}
                  />
                  <MiniBrowser
                    src={getNewUrl(
                      tab.title === "Powerpoint"
                        ? powerpointPath
                        : documentationPath
                    )}
                    relativePath={documentationPath}
                    className={`${
                      tab.isActive ? "block" : "hidden"
                    } p-2 rounded-[30px] bg-white dark:bg-vs-dark-background-lighter overflow-hidden`}
                    key={tab.id}
                    refrence={documentationRef}
                  />
                  {checkPoint && (
                    <div className="bg-riders-green py-0.5 text-sm px-5 rounded-b-2xl text-white absolute right-10 top-0">
                      Checkpoint
                    </div>
                  )}
                </div>
              );
            case "blockly":
              return (
                <div
                  className={classNames(
                    "flex flex-col rounded-t-[15px] overflow-hidden h-full code-tab",
                    {
                      "fixed top-5 right-4 bottom-5 z-[300]":
                        fullscreen === "blockly",
                      "left-[100px]":
                        collapsedSidebar && fullscreen === "blockly",
                      "left-[330px]":
                        !collapsedSidebar && fullscreen === "blockly",
                      "h-full": fullscreen !== "blockly",
                    }
                  )}
                  key={`${tab.id}-${fullscreen}`}
                >
                  <div className="w-full h-8 px-3 bg-white">
                    <div className="w-full h-8 bg-white space-x-4 items-end justify-between flex px-4 text-gray-500 border-b-2">
                      <div className="flex items-end">
                        <span
                          className={classNames(
                            "px-2 text-xs box-border cursor-pointer pb-1",
                            {
                              "border-b-2 border-[#5DDEA6]": !preview,
                            }
                          )}
                          onClick={() => setPreview(false)}
                        >
                          <div className="flex space-x-1 items-center -mb-1">
                            <img
                              src="https://editor.riders.ai/icons/blockly.svg"
                              alt="blockly"
                            />
                            <span>Blockly</span>
                          </div>
                        </span>
                        <span
                          className={classNames(
                            "px-2 text-xs box-border cursor-pointer pb-1",
                            {
                              "border-b-2 border-[#5DDEA6]": preview,
                            }
                          )}
                          onClick={() => setPreview(true)}
                        >
                          <div className="flex space-x-1 items-center -mb-1">
                            <img
                              src="https://editor.riders.ai/icons/preview.svg"
                              alt="preview"
                            />
                            <span>
                              <FormattedMessage id="preview" />
                            </span>
                          </div>
                        </span>
                      </div>
                      <span
                        className="hover:text-xl transition-all cursor-pointer pb-1"
                        onClick={() => {
                          setFullscreen(
                            fullscreen === "blockly" ? null : "blockly"
                          );
                        }}
                      >
                        {fullscreen === "blockly" ? (
                          <MdFullscreenExit />
                        ) : (
                          <MdFullscreen />
                        )}
                      </span>
                    </div>
                  </div>
                  {preview && (
                    <Editor
                      file_path={filePath}
                      code={""}
                      setCode={(code: string) => {}}
                      className={classNames(
                        checkPoint ? "order-2" : "",
                        `pt-1 fit rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white code-tab ${
                          tab.isActive ? "block" : "hidden"
                        }`
                      )}
                      setMount={(editor: any) => {}}
                      readonly
                      key={tab.id + editorId}
                      editorClassName="w-full h-full rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white overflow-hidden"
                    />
                  )}

                  {project.blocklyTheme === "microbit" && !preview && (
                    <MicrobitBlock
                      project={project}
                      projectConfig={projectConfig}
                      setCode={(code: string) => {
                        if (!code) {
                          return;
                        }
                        setPythonCode(code);
                      }}
                      setXML={(xml) => {
                        writeFile(blocklySource, xml);
                      }}
                      key={tab.id + editorId + blocklyKey + refreshKey}
                      className={classNames(
                        checkPoint ? "order-2" : "",
                        "fit rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white overflow-hidden"
                      )}
                      file_path={blocklySource}
                    />
                  )}

                  {project.language === "ino" && !preview && (
                    <RidersBlock
                      project={project}
                      projectConfig={projectConfig}
                      setCode={(code: string) => {
                        if (!code) {
                          return;
                        }
                        setPythonCode(code);
                      }}
                      setXML={(xml) => {
                        writeFile(blocklySource, xml);
                      }}
                      key={tab.id + editorId + refreshKey}
                      className={classNames(
                        checkPoint ? "order-2" : "",
                        "fit rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white overflow-hidden code-tab"
                      )}
                      file_path={blocklySource}
                    />
                  )}

                  {project.language === "cpp" && !preview && (
                    <DeneyapBlock
                      project={project}
                      projectConfig={projectConfig}
                      setCode={(code: string) => {
                        if (!code) {
                          return;
                        }
                        setPythonCode(code);
                      }}
                      setXML={(xml) => {
                        writeFile(blocklySource, xml);
                      }}
                      key={tab.id + editorId + refreshKey}
                      className={classNames(
                        checkPoint ? "order-2" : "",
                        "fit rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white overflow-hidden code-tab"
                      )}
                      file_path={blocklySource}
                    />
                  )}

                  {!["ino", "cpp"].includes(project.language) &&
                    !preview &&
                    blocklyKey === null && (
                      <div className="w-full h-full bg-white rounded-b-[30px] flex items-center justify-center">
                        <span className="flex space-x-3 items-center">
                          <Spin />
                          <span>
                            <FormattedMessage id="blockly_not_available" />
                          </span>
                        </span>
                      </div>
                    )}

                  {!["ino", "cpp"].includes(project.language) &&
                    project.blocklyTheme !== "microbit" &&
                    !preview &&
                    blocklyKey && (
                      <BEditor
                        key={tab.id + editorId + blocklyKey + refreshKey}
                        project={project}
                        projectConfig={projectConfig}
                        setCode={(code: string) => {
                          if (!code) {
                            return;
                          }
                          setPythonCode(code);
                        }}
                        setXML={(xml) => {
                          writeFile(blocklySource, xml);
                        }}
                        className={classNames(
                          checkPoint ? "order-2" : "",
                          "fit rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white overflow-hidden code-tab"
                        )}
                        file_path={blocklySource}
                      />
                    )}
                </div>
              );
            default:
              return (
                <div
                  className={classNames(
                    "flex flex-col rounded-t-[15px] overflow-hidden h-full code-tab",
                    {
                      "fixed top-5 right-4 bottom-5 z-[300]":
                        fullscreen === "blockly",
                      "left-[100px]":
                        collapsedSidebar && fullscreen === "blockly",
                      "left-[330px]":
                        !collapsedSidebar && fullscreen === "blockly",
                    }
                  )}
                  key={`${tab.id}-${fullscreen}`}
                >
                  <div className="w-full h-8 px-3 bg-white">
                    <div className="w-full h-8 bg-white space-x-4 items-end justify-between flex px-4 text-gray-500 border-b-2">
                      <div className="flex items-end">
                        {/* <span
                        className={classNames(
                          "px-2 border-b-2 text-xs box-border cursor-pointer pb-1",
                          {
                            "border-[#5DDEA6]": !preview,
                            "border-slate-200": preview,
                          }
                        )}
                        onClick={() => setPreview(false)}
                      >
                        <div className="flex space-x-1 items-center -mb-1">
                          <IoCodeSlashOutline />
                          <span>{"usercode"}</span>
                        </div>
                      </span> */}
                      </div>
                      <span
                        className="hover:text-xl transition-all cursor-pointer pb-1"
                        onClick={() => {
                          setFullscreen(
                            fullscreen === "blockly" ? null : "blockly"
                          );
                        }}
                      >
                        {fullscreen === "blockly" ? (
                          <MdFullscreenExit />
                        ) : (
                          <MdFullscreen />
                        )}
                      </span>
                    </div>
                  </div>
                  <Editor
                    file_path={tab.path}
                    code={tab.content}
                    setCode={(code: string) => {
                      writeFile(tab.path, code);
                    }}
                    className={classNames(
                      checkPoint ? "order-2" : "",
                      `pt-1 fit rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white code-tab ${
                        tab.isActive ? "block" : "hidden"
                      }`
                    )}
                    setMount={(editor: any) => {
                      editor._focusTracker.onChange(() => {
                        if (editor._focusTracker.hasFocus()) {
                          setEditorFocus({
                            workspaceId,
                            tabId: tab.id,
                            title: tab.title,
                          });
                        } else {
                          setEditorFocus(undefined);
                        }
                      });
                    }}
                    key={tab.id + editorId}
                    editorClassName="w-full h-full rounded-b-[30px] dark:bg-vs-dark-background-lighter bg-white overflow-hidden"
                  />
                </div>
              );
          }
        })}
      </div>
    </div>
  );
};
